import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import styled from "styled-components";

const ContainerSkeleton=styled.div`
display:grid;
justify-items:center;`;

const SkeletonCostumers = () => 
{
    return <>
     <ContainerSkeleton>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
        <Skeleton animation="wave" height={"35px"} width={"90%"}/>
    </ContainerSkeleton>
    </>
}

export default SkeletonCostumers
